export default "__VITE_ASSET__CRltdoJ$__"